var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "arrow-up_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#arrow-up_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M12 10.454 7.927 14.51a.744.744 0 0 1-.515.22.697.697 0 0 1-.539-.22.717.717 0 0 1-.217-.526c0-.207.072-.382.217-.527l4.048-4.048c.294-.294.653-.44 1.079-.44.426 0 .785.146 1.079.44l4.048 4.048c.138.138.212.31.22.514a.697.697 0 0 1-.22.54.717.717 0 0 1-.527.217.717.717 0 0 1-.527-.217L12 10.454Z",
    fill: "currentColor"
  }))));
};
export default SvgArrowUp;